import { createConfirmation } from "react-confirm";
import { ConfirmModal }       from "components/ui";

const confirm = createConfirmation(ConfirmModal);

export default function (options = {}) {
  return confirm({ options });
}
